'use client';

import { CTALink } from 'components/shared';
import { CustomImage, useModal } from 'components';
import { useSearchParams } from 'next/navigation';
import { useMemo } from 'react';
import { PartnersTypeform } from '../PartnersTypeform';
import styles from './HeroCatSection.module.css';

export const Hero = ({
  className,
  title,
  subTitle,
  img,
  rootClass,
  cta,
  categoryTitle,
}: {
  className?: string;
  title: string;
  subTitle?: string;
  rootClass?: string;
  img?: {
    desktopSrc: string;
    mobileSrc: string;
    alt: string;
    width: number;
    height: number;
    caption?: string;
    captiionAlignment?: 'left' | 'right';
  };
  cta?: {
    text: string;
    link: string;
    rootClass?: string;
    heroCategory?: string;
  };
  categoryTitle?: string;
}) => {
  const searchParams = useSearchParams();
  const routerQuery = useMemo(() => {
    const query: Record<string, string | string[]> = {};
    if (!searchParams) return query;
    for (const key of searchParams.keys()) {
      const values = searchParams.getAll(key);
      query[key] = values.length > 1 ? values : values[0];
    }
    return query;
  }, [searchParams]);

  const linkHref = {
    pathname: cta?.link,
    query: {
      ...routerQuery,
      ...(cta?.heroCategory ? { heroCategory: cta.heroCategory } : {}),
    },
  };

  const ModalClient = useModal();

  const handleLinkCLick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    ModalClient.setCloseButtonTheme('light');
    ModalClient.set(<PartnersTypeform />);
    ModalClient.show();
  };

  return (
    <div
      className={`${styles.root} ${rootClass}${className ? ` ${className}` : ''}`}
    >
      <div className={styles.textContainer}>
        <h3>{title}</h3>
        {subTitle ? <p className={styles.description}>{subTitle}</p> : null}
        {cta ? (
          <CTALink
            className={cta.rootClass || ''}
            onClick={handleLinkCLick}
            href={linkHref}
          >
            {cta.text}
          </CTALink>
        ) : null}
      </div>
      {img ? (
        <div className={styles.imgContainer}>
          <div className={styles.imgWrapper}>
            <CustomImage
              src={`web_v2/partners/partner-categories/${img.desktopSrc}`}
              alt={img.alt}
              fill
            />
          </div>
          {img.caption ? (
            <div
              className={`${styles.imgTextContainer} ${img.captiionAlignment}`}
            >
              <p className={styles.captionTitle}>
                Ultrahuman for <b>{categoryTitle}</b>
              </p>
              <p>{img.caption}</p>
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};
